import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.auth_status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "auth_status", $$v);
      },
      expression: "searchForm.auth_status"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "-1"
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("待审核")]), _c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("待实名")]), _c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("已实名")]), _c("el-radio-button", {
    attrs: {
      label: "4"
    }
  }, [_vm._v("实名失败")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "实名类别"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.auth_scene,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "auth_scene", $$v);
      },
      expression: "searchForm.auth_scene"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: undefined
    }
  }), _c("el-option", {
    attrs: {
      label: "诈骗",
      value: "fraud"
    }
  }), _c("el-option", {
    attrs: {
      label: "拉客",
      value: "solicit"
    }
  }), _c("el-option", {
    attrs: {
      label: "诈骗IP",
      value: "fraud_ip"
    }
  }), _c("el-option", {
    attrs: {
      label: "诈骗IP段",
      value: "fraud_ip_segment"
    }
  }), _c("el-option", {
    attrs: {
      label: "突破会话数限制",
      value: "conversation_limit"
    }
  }), _c("el-option", {
    attrs: {
      label: "小程序风险等级为4",
      value: "wx_risk_rank_4"
    }
  }), _c("el-option", {
    attrs: {
      label: "命中高危诈骗词",
      value: "hit_high_risk_fraud_keywords"
    }
  }), _c("el-option", {
    attrs: {
      label: "篡改设备ID",
      value: "tampered_device_id"
    }
  }), _vm._l(_vm.authSceneRiskCodeList, function (item) {
    return _c("el-option", {
      key: item.scene,
      attrs: {
        label: item.label,
        value: item.scene
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "用户状态"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: undefined
    }
  }), _c("el-option", {
    attrs: {
      label: "正常",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "已禁言",
      value: 2
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "实名时间"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "250px"
    },
    attrs: {
      type: "daterange",
      "range-separator": "-",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.pickerOptions
    },
    on: {
      change: _vm.handleDateChange
    },
    model: {
      value: _vm.searchForm.time,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "time", $$v);
      },
      expression: "searchForm.time"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          auth_status: -1
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")]), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.addDialog
    }
  }, [_vm._v("添加")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "姓名",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          deviceRiskInfo = _ref$row.deviceRiskInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo,
            deviceRisk: "",
            deviceRiskInfo: deviceRiskInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "手机",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.auth_status == 1 ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("待实名")]) : _vm._e(), scope.row.auth_status == 2 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("待审核")]) : _vm._e(), scope.row.auth_status == 3 ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("已实名")]) : _vm._e(), scope.row.auth_status == 4 ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("实名失败")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "证件信息",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.auth_info ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            content: scope.row.auth_info.idcard_number,
            trigger: "hover"
          }
        }, [_c("el-link", {
          attrs: {
            slot: "reference",
            type: "primary"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.$router.push("/user/real-name?number=".concat(scope.row.auth_info.idcard_number));
            }
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.auth_info.idcard_name) + " "), scope.row.auth_info.total > 1 ? _c("span", [_vm._v(" * " + _vm._s(scope.row.auth_info.total))]) : _vm._e()])], 1) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "实名类别",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.auth_scene == "fraud" ? _c("span", [_vm._v("诈骗")]) : _vm._e(), scope.row.auth_scene == "solicit" ? _c("span", [_vm._v("拉客")]) : _vm._e(), scope.row.auth_scene == "fraud_ip" ? _c("span", [_vm._v("诈骗IP")]) : _vm._e(), scope.row.auth_scene == "fraud_ip_segment" ? _c("span", [_vm._v("诈骗IP段")]) : _vm._e(), scope.row.auth_scene == "conversation_limit" ? _c("span", [_vm._v("突破会话数限制")]) : _vm._e(), scope.row.auth_scene == "wx_risk_rank_4" ? _c("span", [_vm._v("小程序风险等级为4")]) : _vm._e(), scope.row.auth_scene == "hit_high_risk_fraud_keywords" ? _c("span", [_vm._v("命中高危诈骗词")]) : _vm._e(), scope.row.auth_scene == "tampered_device_id" ? _c("span", [_vm._v("篡改设备ID")]) : _vm._e(), _c("span", [_vm._v(_vm._s(_vm.getAuthSceneLabel(scope.row.auth_scene)))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "聊天"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-im-count", {
          attrs: {
            count: scope.row.im_count,
            userId: scope.row.id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.remark_log,
            remark: scope.row.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "用户标签",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-table-tag", {
          attrs: {
            userId: scope.row.id,
            list: scope.row.userTag
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "auth_set_time",
      label: "设实名时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "auth_info.created_at",
      label: "实名时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "150",
      align: "center",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.auth_status === 2 ? _c("el-button", {
          staticClass: "wlc-button-succes",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.audit(scope.row, 3);
            }
          }
        }, [_vm._v("通过 ")]) : _vm._e(), scope.row.auth_status === 2 ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.audit(scope.row, 4);
            }
          }
        }, [_vm._v("拒绝 ")]) : _vm._e(), scope.row.auth_status === 1 || scope.row.auth_status === 4 ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.audit(scope.row, 0);
            }
          }
        }, [_vm._v("取消认证 ")]) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.count,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "\u8BBE\u4E3A\u5F3A\u5236\u5B9E\u540D",
      width: "300px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "40px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "类型"
    }
  }, [_c("el-select", {
    model: {
      value: _vm.form.scene,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "scene", $$v);
      },
      expression: "form.scene"
    }
  }, [_c("el-option", {
    attrs: {
      label: "高危诈骗",
      value: "fraud"
    }
  })], 1)], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.setUserForcAuth
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };